import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux-immutable';

var paginationReducer = function paginationReducer(actionRoot) {
  var SET_PAGE = "SET_".concat(actionRoot, "_PAGE");
  var SET_TOTAL = "SET_".concat(actionRoot, "_TOTAL");
  var page = handleActions(_defineProperty({}, SET_PAGE, function (_state, action) {
    return action.payload;
  }), 1);
  var total = handleActions(_defineProperty({}, SET_TOTAL, function (_state, action) {
    return action.payload;
  }), null);
  return combineReducers({
    page: page,
    total: total
  });
};

export default paginationReducer;